export const iconFontAwesomeCodingCodeBranch = (
	<i className="fa-solid fa-code-branch"></i>
);
